<template>
  <div ref="container">
    <a-modal
      :title="title"
      :width="500"
      :visible="visible"
      :confirmLoading="confirmLoading"
      :getContainer="() => $refs.container"
      :maskStyle="{'top':'93px','left':'154px'}"
      :mask="isDesktop()"
      :maskClosable="false"
      @ok="handleOk"
      @cancel="handleCancel"
      cancelText="取消"
      okText="保存"
      style="top:100px;">
      <a-spin :spinning="confirmLoading">
        <a-form :form="form">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="区域名称">
            <a-input placeholder="请输入区域名称" v-decorator.trim="['name', validatorRules.name]" />
          </a-form-item>
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="排序">
            <a-input-number style="width: 100%" :min="0" placeholder="数字越小越靠前" v-decorator="['sort', { initialValue: 0 }]" />
          </a-form-item>
        </a-form>
      </a-spin>
    </a-modal>
  </div>
</template>
<script>
import pick from 'lodash.pick'
import { areaAdd, areaUpdate } from '@/api/plugin/dining'
import { mixinDevice } from '@/utils/mixin'

export default {
  name: 'DiningAreaModal',
  mixins: [mixinDevice],
  props: {
    storeId: { type: Number, default: null }
  },
  data() {
    return {
      title: '操作',
      visible: false,
      model: {},
      labelCol: { span: 6 },
      wrapperCol: { span: 17, offset: 1 },
      confirmLoading: false,
      form: this.$form.createForm(this),
      validatorRules: {
        name: {
          rules: [
            { required: true, message: '请输入区域名称!' },
            { max: 30, message: '长度不能超过 30 个字符', trigger: 'blur' }
          ]
        }
      }
    }
  },
  methods: {
    add() {
      this.edit({})
    },
    edit(record) {
      this.form.resetFields()
      this.model = Object.assign({}, record)
      this.visible = true
      this.$nextTick(() => {
        this.form.setFieldsValue(pick(this.model, 'name', 'sort'))
      })
    },
    close() {
      this.$emit('close')
      this.visible = false
    },
    handleOk() {
      const that = this
      this.form.validateFields((err, values) => {
        if (!err) {
          that.confirmLoading = true
          // 后端契约：新增 POST /table-area?storeId（storeId 在 query）+ body；编辑 PUT /table-area/{id}
          let obj
          if (!this.model.id) {
            obj = areaAdd(this.storeId, values)
          } else {
            obj = areaUpdate(this.model.id, values)
          }
          obj.then(res => {
            if (res.code === 200) {
              that.$message.success(res.message)
              that.$emit('ok')
            } else {
              that.$message.warning(res.message)
            }
          }).finally(() => {
            that.confirmLoading = false
            that.close()
          })
        }
      })
    },
    handleCancel() {
      this.close()
    }
  }
}
</script>
<style scoped>
</style>
